module.exports = __webpack_public_path__ + "img/backgroundFeature-3.d4a2f539.svg";